import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from '../../services/api.service';
import { generateDeleteText } from '../../helpers/helper';

@Component({
  selector: 'app-customergroupdelete',
  templateUrl: './customergroupdelete.component.html',
  styleUrls: ['./customergroupdelete.component.scss']
})
export class CustomergroupdeleteComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  deleteText: string = generateDeleteText();
  deleteInput: string|null = null;

  customerGroupId: number;
  loading = false;

  constructor(
    private apiService: ApiService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.customerGroupId = this.config.data.customerGroupId;
  }
  delete(): void {
      this.loading = true;
      this.apiService.deleteCustomerGroup(this.customerGroupId).subscribe(() => {
          this.close(true);
      }).add(() => {
          this.loading = false;
      });
  }
  close(result: boolean = false): void {
      this.ref.close(result);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }
}
